import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Typed useDispatch hook
export const useAppDispatch: () => AppDispatch = useDispatch;

// Typed useSelector hook
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
